import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import VisionPage from './pages/Vision';
import WhitepaperPage from './pages/Whitepaper';
import ManifestoPage from './pages/Manifesto';
import TrustFrameworkPage from './pages/TrustFramework';
import PlatformPage from './pages/Platform';
import TermsPage from './pages/Terms';
import CoalitionPage from './pages/Coalition';
import InnovationPage from './pages/Innovation';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/vision" element={<VisionPage />} />
        <Route path="/coalition" element={<CoalitionPage />} />
        <Route path="/whitepaper" element={<WhitepaperPage />} />
        <Route path="/manifesto" element={<ManifestoPage />} />
        <Route path="/trust-framework" element={<TrustFrameworkPage />} />
        <Route path="/platform" element={<PlatformPage />} />
        <Route path="/innovation" element={<InnovationPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </Router>
  );
};

export default App;